import React, { useCallback, useRef } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { PrimeIcons } from "primereact/api";
import ReportsMessages from "reports/intl/ReportsMessages";
import useDownloadDataReport from "reports/data-export/data-export-list/hooks/useDownloadDataReport";
import PrimeReactConstants from "core/app/util/PrimeReactConstants";

const { TOP } = PrimeReactConstants;
const { DOWNLOAD } = PrimeIcons;

const tooltipOptions = { position: TOP };

const DownloadBtn = (reportInfo) => {
  const { formatMessage } = useIntl();
  const toastRef = useRef(null);
  const { isSending, handleExport } = useDownloadDataReport(toastRef);

  const handleClick = useCallback(() => {
    handleExport(reportInfo);
  }, [handleExport, reportInfo]);

  return (
    <>
      <Toast ref={toastRef} />
      <Button
        outlined
        disabled={isSending}
        icon={DOWNLOAD}
        onClick={handleClick}
        tooltip={formatMessage(ReportsMessages.exportReport)}
        tooltipOptions={tooltipOptions}
        text
      />
    </>
  );
};

DownloadBtn.propTypes = {
  props: PropTypes.shape({
    first: PropTypes.number,
    rows: PropTypes.number,
    totalRecords: PropTypes.number,
  }),
};

export default DownloadBtn;
